import { render, staticRenderFns } from "./TableResumenCall.vue?vue&type=template&id=50afb3c9&scoped=true&"
import script from "./TableResumenCall.vue?vue&type=script&lang=js&"
export * from "./TableResumenCall.vue?vue&type=script&lang=js&"
import style0 from "./TableResumenCall.vue?vue&type=style&index=0&id=50afb3c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50afb3c9",
  null
  
)

export default component.exports